export const QuestionType = {
    DROPDOWN: 'Dropdown',
    TEXTFIELD: 'Textfield',
    TEXT_AREA: 'Text Area',
    NUMBER_FIELD: 'Number Field',
    DATE_FIELD: 'Date Field',
    RADIO: 'Radio',
    MULTI_SELECT: 'Multi Select',
    LIST: 'List',
};

export const TextValidation = {
    NONE: 'None',
    EMAIL: 'Email',
};

export const BookingStep = {
    TIMESLOT_SELECTION: 'timeslot selection',
    AUTH_SELECTION: 'auth selection',
    REGISTRATION: 'registration',
    ADDRESS: 'address',
    VERIFICATION_CODE: 'verification code',
    CONFIRM_APPOINTMENT: 'confirm appointment',
    CONSENT: 'treatment consent',
    INVALID_TIMESLOT: 'invalid timeslot',
    // Entry step for the chain booking modal. Lands on the suggestions screen — a minimal stub for
    // now — so the chain flow opens its own modal instead of the single-appointment timeslot flow.
    CHAIN_SUGGESTIONS: 'chain suggestions',
};

export const MIN_SEARCH_LENGTH = 1;

export const ALL_CATEGORIES_KEY = '__all__';

// Chains carry no category of their own, so the browser groups them under a synthetic one.
export const CHAINS_CATEGORY_KEY = '__chains__';

// Published by Header, consumed as a scroll-margin so anchors clear the sticky header.
export const APP_HEADER_HEIGHT_VAR = '--app-header-height';

export const ACCORDION_VIEW_APPOINTMENT_SELECTION_LIMIT = 3;

export const DEFAULT_COUNTRY = 'DE';

export const HealthInsurance = {
    PUBLIC: 'public',
    PRIVATE: 'private',
    SELF_PAYER: 'self_payer',
};

export const InsuranceType = {
    PUBLIC: 'PUBLIC',
    PRIVATE: 'PRIVATE',
    SELF_PAYER: 'SELF_PAYER',
};

// Appointment collection kind and booking outcome.
export const CollectionType = {
    SERIES: 'SERIES',
    CHAIN: 'CHAIN',
};

export const CollectionStatus = {
    PENDING: 'PENDING',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
    CANCELLED: 'CANCELLED',
};

export const XUND_RESULT_TYPE = {
    EMERGENCY: 'emergency',
    NO_TREATMENT: 'no-treatment',
    SUCCESS: 'success',
};

export const XUND_SPECIALIZATION_TYPE = {
    HOSPITAL: 'HOSPITAL',
    DOCTOR: 'DOCTOR',
    PHARMACY: 'PHARMACY',
};

// Xund iframe result ids mapped to our treatments
export const XUND_TO_TREATMENT_MAPPINGS_DEV = {
    '49878ce1-ec28-42ba-834d-e227760cb834': 'gyn-urgent-dev', // Gynäkologie
    'eea0cb97-40d6-4abe-ac4f-8bde5aed1d44': 'pneumo-control-follow-up-dev', // Rheumatologische Sprechstunde
    '31d928e7-2fd6-4508-a75d-2fbcf070ab2e': 'gyn-pelvic-floor-dev', // Kardiologische Sprechstunde
    '84ed952b-cadf-42ad-a70d-71fdc6d5894d': 'general-medicine-consultation-hour', // Gastroenterologische Sprechstunde
    '97ee2ab6-6068-4cd1-9a3e-b8f837e42af2': 'general-medicine-vaccination-consultation', // Allgemeine Sprechstunde
};

// Xund iframe result ids mapped to our treatments of KFH "294d6207-8d2d-447a-a2b3-54cb15af294c"
// xund_id: prismic_key
export const XUND_TO_TREATMENT_MAPPINGS_KFH = {
    '49878ce1-ec28-42ba-834d-e227760cb834': 'kfh-first-presentation-nephrology', // Gynäkologische Sprechstunde
    'eea0cb97-40d6-4abe-ac4f-8bde5aed1d44': 'kfh-dialysis', // Rheumatologische Sprechstunde
    '31d928e7-2fd6-4508-a75d-2fbcf070ab2e': 'kfh-biopsy-prep', // Kardiologische Sprechstunde
    '84ed952b-cadf-42ad-a70d-71fdc6d5894d': 'kfh-transplant-aftercare', // Gastroenterologische Sprechstnde
    '97ee2ab6-6068-4cd1-9a3e-b8f837e42af2': 'kfh-preparation-kidney-transplantation', // Allgemeine Sprechstunde
};
